// Per-record expiry timers for customer viewers, keyed by customer and viewer so a
// renewal replaces its own timer and leaves an agent's other tabs alone.
//
// A departure nobody announces is why these exist: an agent who stops renewing has
// their record dropped by the broker, and the broker tells no one. Readers cannot
// cover that by filtering on the record's own expiry, because a reader only re-reads
// when the store changes — which is exactly what stops happening.

const expiryTimeouts = new Map();

export function startViewerExpiry(customerId, viewerId, ttlSeconds, resolveViewersStore) {
  const key = expiryKey(customerId, viewerId);
  clearViewerExpiry(customerId, viewerId);

  const timeoutId = setTimeout(() => {
    if (expiryTimeouts.get(key) !== timeoutId) {
      return;
    }
    expiryTimeouts.delete(key);

    // Resolved at fire time rather than captured: the customer may have been
    // unloaded since, and writing then would rebuild what we tore down.
    const viewersStore = resolveViewersStore();
    if (viewersStore) {
      viewersStore.remove(viewerId);
    }
  }, ttlSeconds * 1000);

  expiryTimeouts.set(key, timeoutId);
}

export function clearViewerExpiry(customerId, viewerId) {
  const key = expiryKey(customerId, viewerId);
  const timeoutId = expiryTimeouts.get(key);
  if (timeoutId) {
    clearTimeout(timeoutId);
    expiryTimeouts.delete(key);
  }
}

function expiryKey(customerId, viewerId) {
  return `${customerId}/${viewerId}`;
}
